import { combineSlices } from "@reduxjs/toolkit";
import userSlice from "Data/Redux/Slices/User";
import playbackSlice from "Data/Redux/Slices/Playback";
import userSettingsSlice from "Data/Redux/Slices/UserSettings";
import liveViewSlice from "Data/Redux/Slices/LiveView";
import audioSlice from "Data/Redux/Slices/Settings/Audio/Audio";
import aiAnalyticsSlice from "Data/Redux/Slices/Settings/Camera/AiAnalytics";
import codecSlice from "Data/Redux/Slices/Settings/Camera/Codec";
import embeddedOsdSlice from "Data/Redux/Slices/Settings/Camera/EmbeddedOsd";
import OverlaySlice from "Data/Redux/Slices/Settings/Camera/Overlays";
import imageSlice from "Data/Redux/Slices/Settings/Camera/Image";
import maskSlice from "Data/Redux/Slices/Settings/Camera/Mask";
import motionSlice from "Data/Redux/Slices/Settings/Camera/Motion";
import roiSlice from "Data/Redux/Slices/Settings/Camera/Roi";
import tamperSlice from "Data/Redux/Slices/Settings/Camera/Tamper";
import actionSlice from "Data/Redux/Slices/Settings/Event/Action";
import alarmEventSlice from "Data/Redux/Slices/Settings/Event/Alarm";
import analyticsEventSlice from "Data/Redux/Slices/Settings/Event/Analytics";
import emailRtpSlice from "Data/Redux/Slices/Settings/Event/EmailFtp";
import motionEventSlice from "Data/Redux/Slices/Settings/Event/Motion";
import networkLossEventSlice from "Data/Redux/Slices/Settings/Event/NetworkLoss";
import systemEventSlice from "Data/Redux/Slices/Settings/Event/System";
import tamperEventSlice from "Data/Redux/Slices/Settings/Event/Tamper";
import ipSettingsSlice from "Data/Redux/Slices/Settings/Network/IpSettings";
import multicastSettingsSlice from "Data/Redux/Slices/Settings/Network/MulticastSettings";
import networkSecuritySlice from "Data/Redux/Slices/Settings/Network/Security";
import snmpSlice from "Data/Redux/Slices/Settings/Network/Snmp";
import upnpSlice from "Data/Redux/Slices/Settings/Network/Upnp";
import recordSettingsSlice from "Data/Redux/Slices/Settings/Record/Record";
import sdCardSlice from "Data/Redux/Slices/Settings/Storage/SdCard";
import dateTimeSlice from "Data/Redux/Slices/Settings/System/DateTime";
import systemInformationSlice from "Data/Redux/Slices/Settings/System/Information";
import languageSlice from "Data/Redux/Slices/Settings/System/Language";
import managementSlice from "Data/Redux/Slices/Settings/User/Management";
import scheduleSlice from "Data/Redux/Slices/Settings/System/Schedule";
import systemSecuritySlice from "Data/Redux/Slices/Settings/System/Security";
import authoritySlice from "Data/Redux/Slices/Settings/User/Authority";
import systemManagementSlice from "Data/Redux/Slices/Settings/System/Management";
import dynamicZoomSlice from "Data/Redux/Slices/Settings/Camera/DynamicZoom";

export const rootReducer = combineSlices(
	userSlice, playbackSlice, userSettingsSlice, liveViewSlice, audioSlice, aiAnalyticsSlice, codecSlice,
	embeddedOsdSlice, imageSlice, maskSlice, motionSlice, roiSlice, tamperSlice, actionSlice, alarmEventSlice,
	analyticsEventSlice, emailRtpSlice, motionEventSlice, networkLossEventSlice, systemEventSlice,tamperEventSlice,
	ipSettingsSlice, multicastSettingsSlice, networkSecuritySlice, snmpSlice, upnpSlice, recordSettingsSlice,
	sdCardSlice, dateTimeSlice, systemInformationSlice, languageSlice, managementSlice, scheduleSlice,
	systemSecuritySlice, authoritySlice, systemManagementSlice, dynamicZoomSlice, OverlaySlice
);

export type AppState = ReturnType<typeof rootReducer>;
